<template>
  <div>
    <label class="uk-form-label">{{ label }}</label>
    <div class="uk-form-controls">
      <label
        :class="{ 'uk-form-danger': errors.length }"
        v-for="option in options"
        :key="option"
      >
        <input
          class="uk-checkbox"
          type="checkbox"
          :value="option"
          v-model="selected"
          @change="onChange"
        />
        <span v-html="$t(option)"></span><br>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      required: true,
      Type: String
    },
    options: {
      required: false,
      type: Array,
      default: function() {
        return []
      }
    },
    textSmall: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: []
    }
  },

  methods: {
    onChange() {
      this.$emit('input', this.selected)
    }
  }
}
</script>
